import { Header } from "../../components/Header";
import { MenuClubeDoParque } from "../../components/MenuClubeDoParque";

import { Container } from './styles';

export function ClubeDoParque(props) {
  
  const title = "Clube do Parque";

  return (
    <>
      <Header title={title} />

      <Container>
        <MenuClubeDoParque />
      </Container>
      
    </>
  );
}